import { apiGet, apiPatch, apiPost, apiPut } from './apiClient.js';

export const productionApi = {
  // ----- Work centers
  listWorkCenters:  (params) => apiGet('/api/production/work-centers', params),
  getWorkCenter:    (id)     => apiGet(`/api/production/work-centers/${id}`),
  createWorkCenter: (body)   => apiPost('/api/production/work-centers', body),
  updateWorkCenter: (id, body) => apiPut(`/api/production/work-centers/${id}`, body),

  // ----- Bills of materials
  listBoms:    (params) => apiGet('/api/production/boms', params),
  getBom:      (id)     => apiGet(`/api/production/boms/${id}`),
  createBom:   (body)   => apiPost('/api/production/boms', body),
  updateBom:   (id, body) => apiPut(`/api/production/boms/${id}`, body),
  setBomActive:(id, isActive) => apiPatch(`/api/production/boms/${id}/active`, { isActive }),
  explodeBom:  (id)     => apiGet(`/api/production/boms/${id}/explode`),

  // ----- Work orders
  listWorkOrders:   (params) => apiGet('/api/production/work-orders', params),
  getWorkOrder:     (id)     => apiGet(`/api/production/work-orders/${id}`),
  createWorkOrder:  (body)   => apiPost('/api/production/work-orders', body),
  setWorkOrderStatus:(id, status) => apiPatch(`/api/production/work-orders/${id}/status`, { status }),
  completeWorkOrder:(id)     => apiPatch(`/api/production/work-orders/${id}/complete`),
  confirmWorkOrder: (id, body) => apiPost(`/api/production/work-orders/${id}/confirm`, body),
  listWorkOrderConfirmations: (id) => apiGet(`/api/production/work-orders/${id}/confirmations`),

  // ----- MRP
  explodeMrp: (body) => apiPost('/api/production/mrp/explode', body),
  planMrp:    (body) => apiPost('/api/production/mrp/plan', body),

  // ----- Reports
  workOrderStatus: ()       => apiGet('/api/production/reports/work-order-status'),
  insights:        ()       => apiGet('/api/production/reports/insights'),
  outputTrend:     (params) => apiGet('/api/production/reports/output-trend', params),
  capacity:        (params) => apiGet('/api/production/reports/capacity', params),
};
